import React from 'react';
import Link from 'next/link';

import { IFooter20Fields } from '../../../../../types/contentful';

import { Logo, Tagline } from './styles';

import glFullLogo from '../../../../../public/images/gl-logo-full.svg';

export function FooterImage({
  glTagline,
  glLogo,
  isAffiliateFooter
}: IFooter20Fields) {
  const { file, description } = glLogo?.fields ?? {};

  return (
    <>
      {!isAffiliateFooter ? (
        <Link href="/">
          <Logo
            src={file?.url || glFullLogo}
            alt={description ?? 'Greenlight logo'}
            loading="lazy"
          />
        </Link>
      ) : (
        <Logo
          src={file?.url || glFullLogo}
          isAffiliate={isAffiliateFooter as boolean}
          alt={description ?? 'Greenlight logo'}
          loading="lazy"
        />
      )}
      <Tagline
        fontWeight="400"
        fontSize="h4_0"
        lineHeight="smm"
        colour="white"
        marginTop={{ 0: 'l', desktop: 'ml' }}
      >
        {glTagline}
      </Tagline>
    </>
  );
}
